import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { MessageService } from './message.service';
import { ImportarXmlDIViewModel } from '../model/ImportarXmlDIViewModel';
import { LerXmlDIResponseViewModel } from '../model/LerXmlDIResponseViewModel';
import { Observable } from 'rxjs';
import { ImportarXmlDIResponseViewModel } from '../model/ImportarXmlDIResponseViewModel';
import { SalvarSeparadorRemetenteViewModel } from '../model/SalvarSeparadorRemetenteViewModel';
import { BuscarRemetenteDIViewModel, RemetenteImportacaoViewModel } from '../model/RemetenteImportacaoViewModel';

@Injectable()
export class DeclaracoesImportacaoService extends BaseService {

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  buscarDI(numeroDI: any) {
    return this.http.get(this.UrlService + 'DeclaracoesImportacao/BuscarDI/' + encodeURIComponent(numeroDI))
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  lerXml(dados: ImportarXmlDIViewModel): Observable<LerXmlDIResponseViewModel> {
    dados = {
      ...dados,
      somenteValidar: true,
    };

    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ImportarDI', dados)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  importarXml(dados: ImportarXmlDIViewModel): Observable<ImportarXmlDIResponseViewModel> {
    dados = {
      ...dados,
      somenteValidar: false,
    }

    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ImportarDI', dados)
      .pipe(map((res: any) => res.data));
  }

  atualizarParametrosEntrada(dados: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/AtualizarParametrosEntrada', dados)
      .pipe(map((res: any) => res.data));
  }

  atualizarParametrosSaida(dados: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/AtualizarParametrosSaida', dados)
      .pipe(map((res: any) => res.data));
  }

  alterarPesosDI(dados) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/AlterarPesosDI', dados)
      .pipe(map((res: any) => res.data));
  }

  buscarRemetenteDI(numeroDI: string): Observable<BuscarRemetenteDIViewModel> {
    return this.http.get(this.UrlService + 'DeclaracoesImportacao/BuscarRemetenteDI/' + encodeURIComponent(numeroDI))
      .pipe(map((res: any) => res.data));
  }

  criarOuAtualizarRemetente(numeroDI: any, remetente: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/CriarOuAtualizarRemetente', {
      numeroDI,
      ...remetente,
    }).pipe(map((res: any) => res.data));
  }

  importarItensDI(dadosImportacao: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ImportarItensDI', dadosImportacao)
      .pipe(map((res: any) => res.data));
  }

  importarItensDISaida(dadosImportacao: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ImportarItensDISaida', dadosImportacao)
      .pipe(map((res: any) => res.data));
  }

  salvarSeparadorRemetente(dados: SalvarSeparadorRemetenteViewModel) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/SalvarSeparadorRemetente', dados)
      .pipe(map((res: any) => res.data));
  }

  verificarSeDIFoiCarregada(notaFiscalId: any) {
    return this.http.get(this.UrlService + 'DeclaracoesImportacao/VerificarSeDIFoiCarregada/' + notaFiscalId)
      .pipe(map((res: any) => res.data));
  }

  buscarDuimp(numeroDuimp: any) {
    return this.http.get(this.UrlService + 'DeclaracoesImportacao/BuscarDuimp/' + encodeURIComponent(numeroDuimp))
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  importarItensDuimp(dadosImportacao: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ImportarItensDuimp', dadosImportacao)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  buscarRemetenteDuimp(numeroDUIMP: string): Observable<BuscarRemetenteDIViewModel> {
    return this.http.get(this.UrlService + 'DeclaracoesImportacao/BuscarRemetenteDuimp/' + encodeURIComponent(numeroDUIMP))
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  atualizarDuimpParametrosEntrada(dados: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/AtualizarDuimpParametrosEntrada', dados)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  importarDuimp(numeroDuimp: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ImportarDuimp', { numero: numeroDuimp })
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  atualizarDuimpParametrosSaida(dados: any) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/AtualizarDuimpParametrosSaida', dados)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  buscarItensNotaEntradaParaContaOrdem(nfeEntradaId: any) {
    return this.http.get(this.UrlService + `DeclaracoesImportacao/BuscarItensNotaEntradaParaContaOrdem/${nfeEntradaId}`)
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  carregarDadosNcms(siglaEstado: string, ncms: string[]) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/CarregarDadosNcms', { siglaEstado, ncms })
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  recalcularFormulasCampoCalculado(declaracaoID: number, duimpID: number, campoCalculado: string, notaEntradaImportacaoID: number | null): Observable<any> {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/RecalcularFormulasCampoCalculado', { declaracaoID, duimpID, campoCalculado, notaEntradaImportacaoID })
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  exportarClienteSiscomex(clienteID: number) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/ExportarClienteSiscomex', { clienteID })
      .pipe(map((res: any) => res.data), catchError(super.serviceError));
  }

  atualizarCodigosFiscais(dados) {
    return this.http.post(this.UrlService + 'DeclaracoesImportacao/AtualizarCodigosFiscais', dados)
      .pipe(map((res: any) => res.data));
  }
}
